import styled from "styled-components";
import Overlay from "../../Componentes/Overlay";
import Modal from "../../Componentes/Utils/Modal";
import { useModal } from "../../contexts/ModalContext";
import Tabela from "../../Componentes/Utils/Tabela";
import { useEffect, useState } from "react";

import { FaTrashCan } from "react-icons/fa6";
import { MdEdit } from "react-icons/md";
import ModalEditExame from "./ModalEditExame";
import ModalDeleteExame from "./ModalDeleteExame";


import useApi from "../../hooks/useApi";
const Lixeira = styled(FaTrashCan)`
    color: #ff1919;
    cursor: pointer;
    &:hover {
        color: #e04700;
    }
    font-size: 20px;
`
const Editar = styled(MdEdit)`
    color: #007bff;
    cursor: pointer;
    &:hover {
        color: #0056b3;
    }
    font-size: 22px;
`

const BotaoNovoExame = styled.button`
    width: 200px;
    height: 40px;
    background-color: #4CAF50;
    color: white;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
    border: none;
    border-radius: 5px;
    transition: .3s;
    &:hover {
        background-color: #45a049;
        scale: 1.05;
    }
    margin-left: auto;
    margin-bottom: 10px;
`
const LinhaTabela = styled.tr`
    color: black !important;
    &:nth-child( even ){
        background-color: #f2f2f2 !important;
    }
    &:nth-child( odd ) {
        background-color: #ebebeb  !important;
    }
    &:hover {
        background-color: #d9d9d9 !important;
    }
`


const ModalExamesLista = () => {
    const api = useApi();


    const { closeModal, isModalOpen, openModal } = useModal();

    const [exameSelected, setExameSelected] = useState(null);

    const [exames, setExames] = useState([]);

    const fetchExames = async () => {

        try {

            const { data } = await api.get("/Painel/API/ASO/GetExamesList/");
            console.log(data);

            setExames(data);

        } catch (e) {

            console.error(e)

        }

    }

    useEffect(() => {

        fetchExames();

    }, [])

    const openCreateExame = () => {

        setExameSelected(null);
        openModal('EditExame');

    }

    const openEditExame = (item) => {

        setExameSelected(item);
        openModal('EditExame');

    }

    const openDeleteExame = (item) => {

        setExameSelected(item);
        openModal('deleteExame');

    }

    return (
        <>
            <Overlay state={true} >
                <Modal size="xl" header={true} close={closeModal} >
                    <BotaoNovoExame onClick={openCreateExame} >
                        NOVO EXAME
                    </BotaoNovoExame>
                    <Tabela>
                        <thead>
                            <tr>
                                <th>EXAME</th>
                                <th>CÓDIGO</th>
                                <th></th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                exames.map((exame) => (
                                    <LinhaTabela key={exame.ident} >
                                        <td>{exame.exame}</td>
                                        <td>{exame.codigo}</td>
                                        <td>
                                            <Editar onClick={() => openEditExame(exame)} />
                                        </td>
                                        <td>
                                            <Lixeira onClick={() => openDeleteExame(exame)} />
                                        </td>
                                    </LinhaTabela>
                                ))
                            }
                        </tbody>
                    </Tabela>
                </Modal>
            </Overlay>
            {
                isModalOpen('EditExame') && (
                    <ModalEditExame item={exameSelected} onSuccess={fetchExames} />
                )
            }
            {
                isModalOpen('deleteExame') && (
                    <ModalDeleteExame item={exameSelected} onSuccess={fetchExames} />
                )
            }
        </>
    )
}

export default ModalExamesLista;